var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "MeterConsumptionBrowser",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _c(
        "VueSlickgrid",
        {
          ref: "grid",
          staticClass: "page--grid",
          attrs: {
            name: _vm.gridName,
            headerTitle: _vm._f("pgettext")(
              "Meter Consumptions",
              "MeterConsumptionBrowser"
            ),
            items: _vm.ds,
            "checkbox-row-selection": "",
            "export-to-csv": "",
            exportToCsvFilename: _vm._f("pgettext")(
              "meter-consumptions",
              "MeterConsumptionBrowser|ExportFilename"
            ),
            "footer-totals": "",
            columnDefaults: _vm.b_2248226175642056_columnDefaults,
            columns: _vm.b_2248226175642056_columns
          },
          on: {
            selectedRowsChanged: function($event) {
              return _vm.evh_2248226175642056_selectedRowsChanged($event, {})
            },
            command: function($event) {
              return _vm.evh_2248226175642056_command($event, {})
            }
          }
        },
        [
          _c(
            "DIV",
            {
              staticClass: "flex-grow-1 d-flex",
              attrs: { slot: "toolbar" },
              slot: "toolbar"
            },
            [
              _c(
                "DIV",
                { staticClass: "ml-3" },
                [
                  _c("ItpFormCheckbox", {
                    attrs: {
                      name: "unbilled_only",
                      label: _vm._f("pgettext")(
                        "Unbilled only",
                        "MeterConsumptionBrowser"
                      ),
                      inline: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.evh_4615685607825208_input($event, {})
                      }
                    },
                    model: {
                      value: _vm.dsParams.unbilled_only,
                      callback: function($$v) {
                        _vm.$set(_vm.dsParams, "unbilled_only", $$v)
                      },
                      expression: "dsParams.unbilled_only"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ItpButton", {
                staticClass: "ml-3",
                attrs: {
                  icon: _vm.$config.uploadIcon,
                  text: _vm._f("pgettext")(
                    "Upload readings...",
                    "MeterConsumptionBrowser"
                  ),
                  size: "sm",
                  variant: "light"
                },
                on: {
                  click: function($event) {
                    return _vm.evh_8320016629450276_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("JobHandlerControl", {
                staticClass: "ml-3",
                attrs: {
                  jobType: "generate_meter_consumptions",
                  "load-current": "",
                  payload: _vm.onGenerateMeterConsumptions,
                  icon: "material-symbols:cloud-sync-outline-rounded",
                  text: _vm._f("pgettext")(
                    "Generate Consumptions",
                    "GenerateMeterConsumptions|Submit"
                  ),
                  size: "sm"
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                staticClass: "ml-3",
                attrs: {
                  icon: _vm.$config.meterConsumption.createMeterConsumptionIcon,
                  text: _vm._f("pgettext")(
                    "Add consumption...",
                    "MeterConsumptionBrowser"
                  ),
                  size: "sm",
                  variant: "light"
                },
                on: {
                  click: function($event) {
                    return _vm.evh_6806515264385235_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                staticClass: "ml-3",
                attrs: {
                  icon: "fa-trash",
                  title: _vm._f("pgettext")(
                    "Delete consumption",
                    "MeterConsumptionBrowser"
                  ),
                  text: _vm._f("gettext")("Delete"),
                  size: "sm",
                  variant: "light",
                  disabled: !_vm.selectedItems || !_vm.selectedItems.length,
                  spinning: _vm.actions.deleteItems.isRunning
                },
                on: {
                  click: function($event) {
                    return _vm.evh_8116269939469002_click($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("JobHandlerControl", {
                staticClass: "ml-3 pl-3 border-left",
                attrs: {
                  jobType: "create_invoices_from_consumptions",
                  "load-current": "",
                  payload: _vm.onCreateInvoicesPayload,
                  icon: "mdi:cog",
                  text: _vm._f("pgettext")(
                    "Generate Invoices",
                    "MeterConsumptions|Submit"
                  ),
                  disabled: !_vm.selectedItems || !_vm.selectedItems.length,
                  size: "sm"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }